<template>
  <RegisterForm />
</template>

<script>
import RegisterForm from '@/components/RegisterForm'

export default {
  name: 'register',
  components: {
    RegisterForm
  }
}
</script>
